<template>
  <b-container id="DashboardTop">
    <b-row class="dashboardTitle">
      <b-col xl="6" lg="6" md="6" sm="6">
        <h1>Dashboard</h1>
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="6" >
        <TMGeneralButton
          class="dashCreate"
          text="CREATE SURVEY"
          className="yellow"
          route="NewUserPresentation"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" id="dashboard_info">
        <b-col cols="12" class="pl-4 pr-3">
          <h4>Hello, {{ currentUser.full_name }}</h4>
          <h5>Here’s feedback you can use to improve!</h5>
        </b-col>
        <b-row class="pl-4 pr-3">
          <b-col xl="8" lg="9" md="9" sm="8" class="mb-3 d-flex align-items-center">
            <b-dropdown
              id="lastestPresentations"
              text="Latest Presentations"
              variant="outline-secondary"
              no-flip
            >
              <b-dropdown-header id="lastestPresentationHeader">
                Select up to 6 surveys to compare
              </b-dropdown-header>
              <b-dropdown-form class="dropdown-content">
                <b-form-checkbox
                  v-for="(presentation, idx) in presentations"
                  v-bind:key="idx"
                  :checked="setChecked(idx)"
                  :disabled="setDisabled(idx)"
                  @input.native="selectPresentation($event, idx)"
                  stacked
                >
                  <div class="presentationName">{{ presentation.name }}</div>
                  <div class="presentationDate">
                    {{ formatDate(presentation.presentation_date) }}
                  </div>
                </b-form-checkbox>
                <div class="dropdown-footer">
                    <a :class="['clear-btn', { disabled: selection.length === 0}]" @click="clearPresentations">Clear</a>
                    <TMGeneralButton
                      :class="['save-btn', { disabled: selection.length === 0}]"
                      text="SAVE"
                      @click.native="saveSelection()"
                      className="yellow"
                    />
                </div>
              </b-dropdown-form>
            </b-dropdown>
          </b-col>
          <b-col  xl="3" lg="3" md="3" sm="4">
            <CircleRespondents :respondents="getRespondents()" />
          </b-col>
        </b-row>
        <FeedbackScore 
         text_1="The percentage on the upper right of each chart represents the average score for this key skill for all presentations." 
         text_2="This was calculated by adding the scores for all the answers for this skill and dividing it by the total number of survey respondents."
         text_3="Drop down menu - Surveys average score: Each vertical bar represents one presentation."
         text_4="The percentage on top of the bar is your average score for that key skill. This average was calculated by adding all the scores for the answers in that skill and dividing it by the total number of respondents."
         text_5="Each vertical bar shows the number of individuals who gave you this particular score."
         text_6="Drop down menu - Number of Responses:"
         v-if="!isEmpty"
         class="pl-4"
         />
        <FeedbackScore 
         text_1="The percentage on the upper right of each chart represents the average score for this key skill for all presentations." 
         text_2="This was calculated by adding the scores for all the answers for this skill and dividing it by the total number of respondents. (people who took the surveys)"
         text_3="Each vertical bar represents one presentation."
         text_4="The percentage on top of the bar is your average score for that key skill. This average was calculated by adding all the scores for the answers in that skill and dividing it by the total number of respondents."
         v-else
         class="pl-4"
         />
        <b-col cols="12" class="p-0">
          <div id="dashboard_footer">
            <h4>Keep Transforming Yourself</h4>
            <p>
              Scroll down. Select SEE RESULTS. Start with "Your first priority" from TorchMetrics. Or select the question you will do first. Click on ACTION STEPS. Do Them!
            </p>
          </div>
        </b-col>
      </b-col>
      <b-col xl="8" lg="12" md="12" sm="12" order-xl="2" order-lg="2" order-md="2" order-sm="2" >
        <b-row>
          <b-col xl="6" lg="6" md="6" xm="12">
            <BarDashboard
              icon="/img/dashboardTop/Component 242 – 12@2x.png"
              iconBig="/img/dashboardTop/Component 242 – 12@2x.png"
              title="Content"
              subtitle="Audience-Oriented"
              showChartOptions="true"
              @changeChartOption="changeChartOption"
              :feedback="getMessage('Content')"
              :percentage="promMetrics('Content')"
              :labels="setCharts('Content')"
              :verification="getRespondents()"
            />
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <BarDashboard
              icon="/img/dashboardTop/Component 239 – 12@2x.png"
              iconBig="/img/dashboardTop/Component 239 – 12@2x.png"
              title="Visuals"
              subtitle="Message-Focused"
              showChartOptions="true"
              @changeChartOption="changeChartOption"
              :feedback="getMessage('Visuals')"
              :percentage="promMetrics('Visuals')"
              :labels="setCharts('Visuals')"
              :verification="getRespondents()"
            />
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <BarDashboard
              icon="/img/dashboardTop/Component 242 – 29@2x.png"
              iconBig="/img/dashboardTop/visuals_icon.png"
              title="Delivery"
              subtitle="Persuasive and Confident"
              showChartOptions="true"
              @changeChartOption="changeChartOption"
              :feedback="getMessage('Delivery')"
              :percentage="promMetrics('Delivery')"
              :labels="setCharts('Delivery')"
              :verification="getRespondents()"
            />
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <BarDashboard
              icon="/img/dashboardTop/Component 238 – 11@2x.png"
              iconBig="/img/dashboardTop/connection_icon.png"
              title="Connection"
              subtitle="Engaged and Authentic"
              showChartOptions="true"
              @changeChartOption="changeChartOption"
              :feedback="getMessage('Connection')"
              :percentage="promMetrics('Connection')"
              :labels="setCharts('Connection')"
              :verification="getRespondents()"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import BarDashboard from "@/components/common/BarDashboard";
import CircleRespondents from "@/components/common/CircleRespondents";
import FeedbackScore from "@/components/common/FeedbackScore";
import TMGeneralButton from "@/components/common/TMGeneralButton";
import { mapState, mapActions } from "vuex";
import { 
  getTmScoreRangeInformationByValue, 
  chartData, 
  tmScoresRangesInformationNames,
  tmScoresRangesInformationColors,
  formatDate,
} from "@/services/utils";

export default {
  name: "DashboardTop",
  data: () => ({
    info: {},
    selection: [],
    selected: [],
    presentations: null,
    numberOfPeopleOption: [],
  }),
  computed: {
    ...mapState(["currentUser", "presentations_metrics", "responses_by_scores"]),
    isEmpty() {
      return (this.presentations !== null && this.presentations.length === 0) || (this.presentations === null);
    },
  },
  methods: {
    ...mapActions([
      "GET_RESPONSES_BY_SCORES",
    ]),
    formatDate: formatDate,
    selectDefault(event, idx) {
      this.selected[idx].checked = event.target.checked;
    },
    selectPresentation(event, idx){
      if(!this.selection.includes(idx)){
        this.selection.push(idx);
      }else {
        this.selection = this.selection.filter(element => element !== idx);
      }
    },
    clearPresentations() {
      this.selection = [];
    },
    saveSelection(){
      // clean all selections
      this.selected.map(presentation => {
        presentation.checked = false;
        return presentation;
      });

      if(this.selection.length > 0){
        // check selected selections
        this.selection.forEach(presentation => {
          this.selected[presentation].checked = true;
        });
        this.numberOfPeopleOption.forEach(option => {
          this.loadResponses(option);
        });
      }
    },
    setDisabled(idx){
      return this.selection.length > 5 && !this.selection.includes(idx);
    },
    setChecked(idx){
      return this.selection.includes(idx);
    },
    getRespondents() {
      let respondents = 0;
      var selectedData = this.selected.filter((element) => {
        return element.checked === true;
      });
      selectedData.forEach((element) => {
        respondents += parseInt(element.respondents);
      });
      return respondents;
    },
    getNames() {
      var names = this.filterInfo().map((element) => {
        return element.name.replace(" ", "\n ");
      });
      return names;
    },
    getInfo(searchKey) {
      var arrInfo = this.filterInfo().map((element) => {
        var metric = Math.round(element.metrics[searchKey]);
        return {
          value: metric,
          itemStyle: {
            color: getTmScoreRangeInformationByValue(metric).color,
            borderRadius: [50, 50, 0, 0],
          },
          label: {
            show: true,
            position: "top",
          },
        };
      });
      return arrInfo;
    },
    getMessage(title) {
      return getTmScoreRangeInformationByValue(this.promMetrics(title)).text;
    },
    changeChartOption(title, option){
      if(option === 'number'){
        if(!this.numberOfPeopleOption.includes(title)) this.numberOfPeopleOption.push(title);
      }
      if(option === 'average'){
        if(this.numberOfPeopleOption.includes(title)) this.numberOfPeopleOption = this.numberOfPeopleOption.filter(nop => nop !== title);
      }
    },
    getPresentationsIds(){
      const presentations_ids = this.filterInfo().map(presentation => presentation.id);
      return presentations_ids.join(', ');
    },
    getResponsesNames() {
      const names = ["Other", ...tmScoresRangesInformationNames()]
        .reverse()
        .map((element) => {
          return element.replaceAll(" ", "\n ");
        });
      return names;
    },
    getResponsesInfo(title) {
      const arr = [];
      for (const [key, value] of Object.entries(this.responses_by_scores[title])) {
        arr.push(value);
      }
      var arrInfo = arr.map((element, key) => {
        return {
          value: element,
          itemStyle: {
            color: tmScoresRangesInformationColors()[key],
            borderRadius: [50, 50, 0, 0],
          },
          label: {
            show: true,
            position: "top",
          },
        };
      });
      return arrInfo;
    },
    setCharts(title) {
      if(this.responses_by_scores[title] && this.numberOfPeopleOption.includes(title)){
        const arrInfo = this.getResponsesInfo(title).reverse();
        return chartData(
          arrInfo.length,
          this.getResponsesNames(),
          arrInfo
        );
      }
      return chartData(
        this.selected.length,
        this.getNames(),
        this.getInfo(title),
        100,
        true
      );
    },
    getMetrics(searchKey) {
      var arrInfo = this.filterInfo().map((element) => {
        var metric = Math.round(element.metrics[searchKey]);
        return metric;
      });
      return arrInfo;
    },
    promMetrics(searchKey) {
      var prom = 0;
      var correctValues = 0;
      this.getMetrics(searchKey).forEach((element) => {
        if (element) {
          prom = prom + element;
          correctValues++;
        }
      });
      return Math.round(prom / correctValues);
    },
    filterInfo() {
      var selectedData = this.selected.filter((element) => {
        return element.checked === true;
      });
      return selectedData;
    },
    loadResponses(title){
      const presentations_ids = this.getPresentationsIds();
      this.GET_RESPONSES_BY_SCORES({category: title, presentations_ids: presentations_ids});
    },
  },
  mounted(){
  },
  components: {
    BarDashboard,
    CircleRespondents,
    FeedbackScore,
    TMGeneralButton,
  },
  watch: {
    presentations_metrics: function(value) {
      var maxPresentations = 0;
      var filterInformation = value.filter((element) => {
        return Object.keys(element.metrics).some(
          metric => ["Content", "Connection", "Delivery", "Visuals"].includes(metric)
        );
      });
      var presentations = filterInformation
        .sort(
          (a, b) =>
            new Date(b.presentation_date) - new Date(a.presentation_date)
        )
         .map((element, index) => {
          if (maxPresentations < 6) {
            maxPresentations++;
            this.selection.push(index);
            return {
              ...element,
              checked: true,
            };
          } else {
            return {
              ...element,
              checked: false,
            };
          }
        });
      if (presentations) {
        this.selected = presentations.sort(
          (a, b) => b.presentation_date - a.presentation_date
        );
        this.presentations = presentations;
      }
    },
    numberOfPeopleOption: function(value){
      if(value.length > 0){
        value.forEach(option => {
          this.loadResponses(option);
        });
      }
    },
  },
};
</script>
<style lang="less">
@import "../../assets/components/dashboardTop/DashboardTop.less";
</style>